/* THE STANDARD SOCIETY — HIGH-END THEME JS */

document.addEventListener('DOMContentLoaded', function () {

  /* ---------- LOADER ---------- */
  var loader = document.querySelector('.loader');
  if (loader) {
    window.addEventListener('load', function () {
      setTimeout(function () { loader.classList.add('done'); }, 1400);
    });
    // failsafe
    setTimeout(function () { loader.classList.add('done'); }, 2600);
  }

  /* ---------- SCROLL REVEAL ---------- */
  var revealEls = document.querySelectorAll('[data-reveal]');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ---------- HEADER: transparent over hero -> solid on scroll ---------- */
  var header = document.querySelector('.header');
  var hero = document.querySelector('.hero');
  function onScroll() {
    if (!header) return;
    var threshold = hero ? hero.offsetHeight - 100 : 60;
    if (window.scrollY > threshold) {
      header.classList.add('is-solid');
      header.classList.remove('is-light');
    } else {
      header.classList.remove('is-solid');
      if (hero) header.classList.add('is-light');
    }
  }
  if (hero) header && header.classList.add('is-light');
  else header && header.classList.add('is-solid');
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---------- HERO PARALLAX ---------- */
  var heroImg = document.querySelector('.hero__media img');
  if (heroImg) {
    window.addEventListener('scroll', function () {
      var offset = window.scrollY;
      if (offset < window.innerHeight) {
        heroImg.style.transform = 'translateY(' + offset * 0.25 + 'px) scale(1.05)';
      }
    }, { passive: true });
  }

  /* ---------- OVERLAY MENU ---------- */
  var burger = document.getElementById('burger');
  var overlay = document.getElementById('overlay-menu');
  var overlayClose = document.getElementById('overlay-close');
  function openMenu() { if (overlay) { overlay.classList.add('open'); document.body.style.overflow = 'hidden'; } }
  function closeMenu() { if (overlay) { overlay.classList.remove('open'); document.body.style.overflow = ''; } }
  if (burger) burger.addEventListener('click', openMenu);
  if (overlayClose) overlayClose.addEventListener('click', closeMenu);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeMenu(); closeCart(); } });

  /* ---------- CART DRAWER ---------- */
  var cartToggle = document.getElementById('cart-toggle');
  var cartClose = document.getElementById('cart-close');
  var cart = document.getElementById('cart');
  var cartOv = document.getElementById('cart-ov');
  function openCart() { if (cart) { cart.classList.add('open'); cartOv.classList.add('open'); document.body.style.overflow = 'hidden'; } }
  function closeCart() { if (cart) { cart.classList.remove('open'); cartOv.classList.remove('open'); document.body.style.overflow = ''; } }
  if (cartToggle) cartToggle.addEventListener('click', function (e) { e.preventDefault(); openCart(); });
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOv) cartOv.addEventListener('click', closeCart);

  function updateCount(n) {
    document.querySelectorAll('.count').forEach(function (el) { el.textContent = n; });
  }
  function refreshCart() {
    fetch('/?section_id=header').then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      ['cart-items', 'cart-foot', 'shipbar'].forEach(function (id) {
        var n = doc.getElementById(id), c = document.getElementById(id);
        if (n && c) c.innerHTML = n.innerHTML;
      });
    });
  }

  /* ---------- ADD TO CART (AJAX) ---------- */
  function bindAddToCart() {
    var form = document.getElementById('product-form');
    if (!form) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = document.getElementById('atc');
      var orig = btn ? btn.textContent : '';
      if (btn) { btn.textContent = 'Adding…'; btn.disabled = true; }
      fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
        .then(function (r) { return r.json(); })
        .then(function () { return fetch('/cart.js'); })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          updateCount(c.item_count);
          if (btn) { btn.textContent = 'Added ✓'; setTimeout(function () { btn.textContent = orig; btn.disabled = false; }, 1800); }
          refreshCart(); openCart();
        })
        .catch(function () { if (btn) { btn.textContent = orig; btn.disabled = false; } });
    });
  }
  bindAddToCart();

  /* ---------- CART QTY ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-action]');
    if (!b) return;
    var line = b.dataset.line; if (!line) return;
    var span = b.parentNode.querySelector('span');
    var cur = parseInt(span ? span.textContent : '1', 10);
    var next = b.dataset.action === 'increase' ? cur + 1 : Math.max(0, cur - 1);
    fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: next })
    }).then(function (r) { return r.json(); }).then(function (c) { updateCount(c.item_count); refreshCart(); });
  });

  /* ---------- ACCORDION ---------- */
  document.querySelectorAll('[data-acc]').forEach(function (t) {
    t.addEventListener('click', function () {
      var c = this.nextElementSibling;
      var open = c.classList.contains('open');
      document.querySelectorAll('.acc__content.open').forEach(function (x) {
        x.classList.remove('open'); x.previousElementSibling.classList.remove('open');
      });
      if (!open) { c.classList.add('open'); this.classList.add('open'); }
    });
  });

  /* ---------- LOOKBOOK DRAG SCROLL ---------- */
  var track = document.querySelector('.lookbook__track');
  if (track) {
    var down = false, startX, scrollLeft;
    track.addEventListener('mousedown', function (e) { down = true; startX = e.pageX; scrollLeft = track.scrollLeft; });
    track.addEventListener('mouseleave', function () { down = false; });
    track.addEventListener('mouseup', function () { down = false; });
    track.addEventListener('mousemove', function (e) {
      if (!down) return; e.preventDefault();
      track.scrollLeft = scrollLeft - (e.pageX - startX) * 1.5;
    });
  }

  /* ---------- DISCOUNT POPUP ---------- */
  var promo = document.getElementById('promo');
  var promoOv = document.getElementById('promo-ov');
  if (promo && promoOv && promo.dataset.enabled === 'true') {
    var SEEN = 'tss_promo_seen';
    function showPromo() {
      if (localStorage.getItem(SEEN)) return;
      promo.classList.add('show'); promoOv.classList.add('show');
    }
    function hidePromo() {
      promo.classList.remove('show'); promoOv.classList.remove('show');
      localStorage.setItem(SEEN, '1');
    }
    if (!localStorage.getItem(SEEN)) {
      var delay = (parseInt(promo.dataset.delay, 10) || 6) * 1000;
      setTimeout(showPromo, delay);
    }
    promoOv.addEventListener('click', hidePromo);
    var pc = document.getElementById('promo-close'); if (pc) pc.addEventListener('click', hidePromo);
    var pd = document.getElementById('promo-decline'); if (pd) pd.addEventListener('click', hidePromo);
    var pdone = document.getElementById('promo-done'); if (pdone) pdone.addEventListener('click', hidePromo);
    var pform = document.getElementById('promo-form');
    if (pform) {
      pform.addEventListener('submit', function () {
        // let Shopify capture the email; reveal the code immediately
        localStorage.setItem(SEEN, '1');
        var s1 = document.getElementById('promo-step1');
        var s2 = document.getElementById('promo-step2');
        if (s1 && s2) { setTimeout(function(){ s1.style.display='none'; s2.style.display='block'; }, 200); }
      });
    }
  }

  /* ---------- COLOUR SWATCHES ---------- */
  var COLORMAP = {
    'black':'#1A1A1A','white':'#F5F2EA','ivory':'#F3EBDD','cream':'#F1E9D9','nude':'#E3C6A8',
    'beige':'#D9C7A8','tan':'#C9A97E','khaki':'#B3A16A','camel':'#C19A6B','caramel':'#A9743B',
    'brown':'#6B4A2F','mocha':'#6F4E37','coffee':'#4B3621','chocolate':'#4B3621',
    'gray':'#9A9A9A','grey':'#9A9A9A','light gray':'#C7C7C7','light grey':'#C7C7C7',
    'dark gray':'#4A4A4A','dark grey':'#4A4A4A','silver':'#C0C0C0','charcoal':'#36454F',
    'blue':'#3B5B8C','navy':'#1F2A44','navy blue':'#1F2A44','marine':'#2A3D66','marine blue':'#2A3D66',
    'fog blue':'#9DB2C9','ocean blue':'#2E6E8E','sky blue':'#8FBCE6','baby blue':'#AEC6E4',
    'blue gray':'#7A8CA3','blue grey':'#7A8CA3','light blue':'#AFC7DE',
    'green':'#4F6B4A','dark green':'#2F4A34','light green':'#B7D3A8','mint green':'#A8D5BA','olive':'#6B6B3A',
    'red':'#8B2E2E','lava':'#8B2E2E','orange':'#C86A2B','transparant':'#E8E8E8','transparent':'#E8E8E8'
  };
  function resolveColor(name){
    if(!name) return null;
    name=name.trim().toLowerCase();
    if(COLORMAP[name]) return COLORMAP[name];
    // try to match any known keyword contained in the name (longest first)
    var keys=Object.keys(COLORMAP).sort(function(a,b){return b.length-a.length;});
    for(var i=0;i<keys.length;i++){ if(name.indexOf(keys[i])>=0) return COLORMAP[keys[i]]; }
    return null;
  }
  document.querySelectorAll('.opt__swatch').forEach(function(sw){
    var hex=resolveColor(sw.getAttribute('data-c'));
    if(hex){ sw.style.background=hex; } else { sw.style.display='none'; sw.parentNode.style.paddingLeft='18px'; }
  });

  /* ---------- CUSTOM CURSOR ---------- */
  if (window.matchMedia('(hover: hover)').matches && window.innerWidth > 900) {
    var cursor = document.createElement('div');
    cursor.className = 'cursor';
    cursor.innerHTML = '<span class="cursor__label">View</span>';
    document.body.appendChild(cursor);
    var cx = 0, cy = 0, tx = 0, ty = 0;
    document.addEventListener('mousemove', function (e) { tx = e.clientX; ty = e.clientY; });
    (function loop() {
      cx += (tx - cx) * 0.18; cy += (ty - cy) * 0.18;
      cursor.style.left = cx + 'px'; cursor.style.top = cy + 'px';
      requestAnimationFrame(loop);
    })();
    var mediaSel = '.card__media, .col-card, .look, .hero, .editorial__media';
    document.querySelectorAll(mediaSel).forEach(function (el) {
      el.addEventListener('mouseenter', function () { cursor.classList.add('is-media'); });
      el.addEventListener('mouseleave', function () { cursor.classList.remove('is-media'); });
    });
  }

  /* ---------- PDP THUMBS ---------- */
  document.querySelectorAll('.pdp__thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var main = document.querySelector('.pdp__gallery-main img');
      var src = this.querySelector('img').dataset.full || this.querySelector('img').src;
      if (main) main.src = src;
      document.querySelectorAll('.pdp__thumb').forEach(function (t) { t.classList.remove('active'); });
      this.classList.add('active');
    });
  });

});
